import React from 'react';
import { InfoIcon } from '@domain-group/fe-co-icon';
import { Tooltip as ToolTip } from '@domain-group/fe-blueprint-ui/tooltip';
import * as styles from './card-rating.style';

export const RMA_DISCLAIMER =
  'Ratings and reviews are sourced from RateMyAgent. Domain does not verify, endorse, or guarantee review accuracy.';

export interface RatingTooltipProps {
  inline?: boolean;
}

const RatingTooltip = ({ inline = false }: RatingTooltipProps): JSX.Element => (
  <ToolTip
    mouseEnterDelay={0.2}
    content={<span css={styles.tooltip}>{RMA_DISCLAIMER}</span>}
    layer="layerFloating"
    placement={inline ? 'right' : 'bottom'}
    trigger="hover"
  >
    <InfoIcon
      size="custom"
      css={styles.infoIcon}
      data-testid="rating-tooltip"
    />
  </ToolTip>
);

export default RatingTooltip;
